const TitleReference = ({ documentTitle = "", metaRows = [] }) => (
  <>
    <table className="pdf-mb-5">
      <tbody>
        <tr>
          <td className="pdf-text-right">
            <span className="pdf-brand pdf-fs-22 pdf-text-red">
              {documentTitle}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    {metaRows.length > 0 && (
      <table className="pdf-table-striped pdf-table-border">
        <tbody>
          {metaRows.map((row, idx) => (
            <tr key={idx}>
              <td>{row.label}</td>
              <td className="pdf-text-right">{row.value || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </>
)

export default TitleReference
